import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ea82f716")

_pushScopeId("data-v-ea82f716")
const _hoisted_1 = { class: "p-d-flex p-flex-row p-ai-center p-flex-wrap" }
const _hoisted_2 = { class: "p-float-label p-mr-auto model-search" }
const _hoisted_3 = { class: "kn-material-input-label" }
const _hoisted_4 = { class: "p-m-2 kn-overflow kn-content-section" }
const _hoisted_5 = {
  key: 1,
  class: "p-grid p-m-2",
  "data-test": "card-container"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_WorkspaceModelsTable = _resolveComponent("WorkspaceModelsTable")
  const _component_Message = _resolveComponent("Message")
  const _component_WorkspaceCard = _resolveComponent("WorkspaceCard")
  const _component_DetailSidebar = _resolveComponent("DetailSidebar")
  const _component_QBE = _resolveComponent("QBE")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-d-flex p-flex-row" }, {
      start: _withId(() => [
        _createVNode(_component_Button, {
          id: "showSidenavIcon",
          icon: "fas fa-bars",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('showMenu')))
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('workspace.myModels.title')), 1)
      ]),
      end: _withId(() => [
        (_ctx.toggleCardDisplay)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              icon: "fas fa-list",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _ctx.toggleDisplayView
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.toggleCardDisplay)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              icon: "fas fa-th-large",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _ctx.toggleDisplayView
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.tableMode === 'Federated')
          ? (_openBlock(), _createBlock(_component_KnFabButton, {
              key: 2,
              icon: "fas fa-plus",
              onClick: _ctx.createNewFederation
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_InputText, {
        class: "kn-material-input p-m-3 model-search",
        modelValue: _ctx.searchWord,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchWord = $event)),
        placeholder: _ctx.$t('common.search'),
        onInput: _ctx.searchItems,
        "data-test": "search-input"
      }, null, 8, ["modelValue", "placeholder", "onInput"]),
      _createVNode("span", _hoisted_2, [
        _createVNode(_component_MultiSelect, {
          class: "kn-material-input kn-width-full",
          style: _ctx.mainDescriptor.style.multiselect,
          modelValue: _ctx.selectedCategories,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedCategories = $event)),
          options: _ctx.modelCategories,
          optionLabel: "VALUE_CD",
          onChange: _ctx.searchItems,
          filter: true
        }, null, 8, ["style", "modelValue", "options", "onChange"]),
        _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('common.category')), 1)
      ]),
      _createVNode(_component_SelectButton, {
        class: "p-mx-2",
        modelValue: _ctx.tableMode,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.tableMode = $event)),
        options: _ctx.selectButtonOptions,
        onClick: _ctx.onTableModeChange
      }, null, 8, ["modelValue", "options", "onClick"])
    ]),
    _createVNode("div", _hoisted_4, [
      (!_ctx.toggleCardDisplay)
        ? (_openBlock(), _createBlock(_component_WorkspaceModelsTable, {
            key: 0,
            propItems: _ctx.filteredItems,
            onSelected: _ctx.setSelectedModel,
            onOpenDatasetInQBEClick: _ctx.openDatasetInQBE,
            onEditDatasetClick: _ctx.editDataset,
            onDeleteDatasetClick: _ctx.deleteDatasetConfirm,
            "data-test": "models-table"
          }, null, 8, ["propItems", "onSelected", "onOpenDatasetInQBEClick", "onEditDatasetClick", "onDeleteDatasetClick"]))
        : _createCommentVNode("", true),
      (_ctx.toggleCardDisplay)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            (_ctx.filteredItems.length === 0)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  class: "kn-flex p-m-2",
                  severity: "info",
                  closable: false,
                  style: _ctx.mainDescriptor.style.message
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
                  ]),
                  _: 1
                }, 8, ["style"]))
              : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.filteredItems, (document, index) => {
                  return (_openBlock(), _createBlock(_component_WorkspaceCard, {
                    key: index,
                    viewType: document && document.federation_id ? 'federationDataset' : 'businessModel',
                    document: document,
                    onOpenSidebar: _ctx.setSelectedModel,
                    onOpenDatasetInQBE: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openDatasetInQBE($event))),
                    onEditDataset: _ctx.editDataset,
                    onDeleteDataset: _ctx.deleteDatasetConfirm,
                    onMonitoring: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showMonitoring = !_ctx.showMonitoring))
                  }, null, 8, ["viewType", "document", "onOpenSidebar", "onEditDataset", "onDeleteDataset"]))
                }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_DetailSidebar, {
      visible: _ctx.showDetailSidebar,
      viewType: _ctx.selectedModel && _ctx.selectedModel.federation_id ? 'federationDataset' : 'businessModel',
      document: _ctx.selectedModel,
      onOpenDatasetInQBE: _cache[7] || (_cache[7] = ($event: any) => (_ctx.openDatasetInQBE($event))),
      onEditDataset: _ctx.editDataset,
      onDeleteDataset: _ctx.deleteDatasetConfirm,
      onMonitoring: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showMonitoring = !_ctx.showMonitoring)),
      onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showDetailSidebar = false)),
      "data-test": "detail-sidebar"
    }, null, 8, ["visible", "viewType", "document", "onEditDataset", "onDeleteDataset"]),
    (_ctx.qbeVisible)
      ? (_openBlock(), _createBlock(_component_QBE, {
          key: 1,
          visible: _ctx.qbeVisible,
          dataset: _ctx.selectedQbeDataset,
          onClose: _ctx.closeQbe
        }, null, 8, ["visible", "dataset", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
})